import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { useEffect, useState } from "react";
import { config } from "../config";
import { useNavigate } from "react-router-dom";
import LoadingModal from "./LoadingModal";
export default function PrivateRoute() {
    const navigate = useNavigate()
    const [sessionStatus, setSessionStatus] = useState('unknown')
    const { sessionToken } = useSelector((state: any) => state.session)

    useEffect(() => {
        async function verifyToken() {
            try {
                let response = await axios.post(`${config.backendUrl}${config.validateSessionUrl}`, { sessionToken })
                console.log(response.data)
                setSessionStatus('valid')
            } catch (err) {
                console.log(err)
                console.log('session invalid')
                navigate('/login')
            }
        }
        verifyToken()
    }, [])
    if (!sessionToken || sessionStatus === 'invalid') {
        return <Navigate to={'/login'} />
    }
    if (sessionToken && sessionStatus === 'unknown') {
        return (
            <div className="h-full">
                <LoadingModal loading />
            </div>
        )
    }
    return <Outlet />
}
